<div
  class="l-modal01__contents l-modal01__contents--w384 js-modal-contents"
  aria-modal="true"
  role="dialog"
  [attr.aria-labelledby]="'m_static_message-label.filter' | staticMsg"
>
  <div class="l-modal01__header js-modal-head">
    <div class="p-modal-head01">
      <h1 id="modalTitle" class="p-modal-head01__title" [innerHTML]="'label.filter' | staticMsg"></h1>
      <button
        id="organization-select-filter-modal-input"
        class="p-modal-head01__close js-modal-close"
        (click)="clickClose()"
      >
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>

  <div class="l-modal01__body js-modal-body">
    <div class="p-form-layout01">
      <div class="p-form-layout01__item">
        <form #form="ngForm" [formGroup]="inputFG">
          <div class="p-input-list02-area01__heading">
            <asw-input
              label="{{ 'm_static_message-label.organizationName' | staticMsg }}"
              formControlName="organization_name"
              maxlength="60"
            ></asw-input>
          </div>
          <div class="p-input-list02">
            <asw-input
              label="{{ 'm_static_message-label.organizationId' | staticMsg }}"
              formControlName="organization_id"
              maxlength="8"
            ></asw-input>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="l-modal01__footer js-modal-footer">
    <div class="p-modal-foot02">
      <asw-button
        id="organization-select-reset-button"
        label="{{ 'm_static_message-label.reset_' | staticMsg }}"
        type="secondary"
        (click$)="resetEvent()"
        [throttleClick]="true"
      ></asw-button>
      <asw-button
        id="organization-select-apply-button"
        label="{{ 'm_static_message-label.applay' | staticMsg }}"
        type="primary"
        [disabled]="!form.form.valid"
        (click$)="applyEvent()"
        [throttleClick]="true"
      ></asw-button>
    </div>
  </div>
</div>
